import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { useCasesGeneralInformationCallInfo } from './hook';
import { CasesGeneralInformationCallInfoProps } from './props';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const CasesGeneralInformationCallInfo = (
    props: CasesGeneralInformationCallInfoProps
) => {
    const {
        formik,
        channels,
        typification1,
        typification2,
        typification3,
        typification4,
        typification5,
        branches,
        isTracking,
        requireAutomobilesClaimFields,
    } = useCasesGeneralInformationCallInfo(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Información de la llamada
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Call ID"
                    name="callId"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.callId}
                    errors={formik.errors.callId}
                    value={formik.values.callId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(channels)}
                    label="Canal"
                    name="channel"
                    size="small"
                    required
                    touched={formik.touched.channel}
                    errors={formik.errors.channel}
                    value={formik.values.channel as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('channel', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typification1)}
                    label="Tipificación 1"
                    name="typification1"
                    size="small"
                    required
                    touched={formik.touched.typification1}
                    errors={formik.errors.typification1}
                    value={formik.values.typification1 as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typification1', value)
                    }
                />
            </Grid>
            {typification2.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(typification2)}
                        label="Tipificación 2"
                        name="typification2"
                        size="small"
                        required
                        touched={formik.touched.typification2}
                        errors={formik.errors.typification2}
                        value={formik.values.typification2 as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('typification2', value)
                        }
                    />
                </Grid>
            )}
            {typification3.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(typification3)}
                        label="Tipificación 3"
                        name="typification3"
                        size="small"
                        required
                        touched={formik.touched.typification3}
                        errors={formik.errors.typification3}
                        value={formik.values.typification3 as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('typification3', value)
                        }
                    />
                </Grid>
            )}
            {typification4.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(typification4)}
                        label="Tipificación 4 (Se presenta novedad)"
                        name="typification4"
                        size="small"
                        required
                        touched={formik.touched.typification4}
                        errors={formik.errors.typification4}
                        value={formik.values.typification4 as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('typification4', value)
                        }
                    />
                </Grid>
            )}
            {typification5.length > 0 && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(typification5)}
                        label="Tipificación 5 (Motivo de la novedad)"
                        name="typification5"
                        size="small"
                        required
                        touched={formik.touched.typification5}
                        errors={formik.errors.typification5}
                        value={formik.values.typification5 as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('typification5', value)
                        }
                    />
                </Grid>
            )}
            {isTracking && (
                <>
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="No. De documento"
                            name="document"
                            size="small"
                            required={requireAutomobilesClaimFields}
                            touched={formik.touched.document}
                            errors={formik.errors.document}
                            value={formik.values.document}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="Placa del vehículo"
                            name="vehiclePlate"
                            size="small"
                            required={requireAutomobilesClaimFields}
                            touched={formik.touched.vehiclePlate}
                            errors={formik.errors.vehiclePlate}
                            value={formik.values.vehiclePlate}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="No. De póliza"
                            name="policyNumber"
                            size="small"
                            required={requireAutomobilesClaimFields}
                            touched={formik.touched.policyNumber}
                            errors={formik.errors.policyNumber}
                            value={formik.values.policyNumber}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <AutocompleteField
                            data={formatParams(branches)}
                            label="Sucursal"
                            name="branch"
                            size="small"
                            required
                            touched={formik.touched.branch}
                            errors={formik.errors.branch}
                            value={formik.values.branch}
                            onChangeValue={(value: any) =>
                                formik.setFieldValue('branch', value)
                            }
                        />
                    </Grid>
                </>
            )}
            <Grid item xs={12}>
                <FieldText
                    label="Observación"
                    name="observation"
                    size="small"
                    required
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.observation}
                    errors={formik.errors.observation}
                    value={formik.values.observation}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="¿Transferencia de asistencia?"
                    checked={Boolean(formik.values.isTransferAssistance)}
                    onChange={() => {
                        formik.setFieldValue(
                            'isTransferAssistance',
                            !formik.values.isTransferAssistance
                        );
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            {props.account?.userAttendanceRequired && (
                <>
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="Identificación usuario asistencia"
                            name="userAttendanceId"
                            size="small"
                            required
                            onBlur={formik.handleBlur}
                            touched={formik.touched.userAttendanceId}
                            errors={formik.errors.userAttendanceId}
                            value={formik.values.userAttendanceId}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="Nombre/ razón social usuario asistencia"
                            name="userAttendanceName"
                            size="small"
                            required
                            onBlur={formik.handleBlur}
                            touched={formik.touched.userAttendanceName}
                            errors={formik.errors.userAttendanceName}
                            value={formik.values.userAttendanceName}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
};
